import { FC } from 'react'
import { BrandFeatureInput } from 'shared/src/api/types'
import { addDisplayName, flowMax } from 'ad-hok'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { ImageField } from './ImageField'
import { ResourceSelectField } from './ResourceSelectField'

export const BrandFeatureForm: FC<FormProps<Partial<BrandFeatureInput>>> =
  flowMax(
    addDisplayName('BrandFeatureForm'),
    addTranslationHelpers,
    ({ values, onChange, errors, t }) => (
      <div>
        <ResourceSelectField
          id="brandId"
          label={t('admin.resources.brandFeatures.fields.brandId')}
          error={errors.brandId}
          resourceName="brands"
          selectedId={values.brandId}
          onChange={(brandId) => onChange({ ...values, brandId })}
          focusOnMount
        />
        <ImageField
          id="imageId"
          label={t('admin.resources.brandFeatures.fields.imageId')}
          value={values.imageId}
          onChange={(imageId) => onChange({ ...values, imageId })}
          error={errors.imageId}
        />
      </div>
    )
  )
